import Yup from 'utils/yup'

export const defaultValues = {
  hours: null,
}

export const validationSchema = Yup.object().shape({
  hours: Yup.number().nullable().required().min(1, 'Quantidade de horas inválida'),
})
